import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import VerAutorizaciones from '../Autorizaciones/VerAutorizaciones';
import { AutorizacionesMobile } from '../Autorizaciones/AutorizacionesMobile';

export const Autorizaciones = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {!isMobileScreen && <VerAutorizaciones />}
      {isMobileScreen && <AutorizacionesMobile />}
    </>
  );
};
